import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-brand-yellow bg-brand-navy" data-id="element-98" data-mp="4mi5dgdtryh4">
      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-99" data-mp="1297c23jh2z9b">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full bg-brand-blue px-3 py-1 font-display text-[0.62rem] font-bold uppercase tracking-[0.12em] text-white" data-id="element-100" data-mp="1274nzp1vrg78">
          <GraduationCapIcon size={12} data-id="element-101" data-mp="3d21uc37gquqd" />
          Método de enseñanza paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 font-display text-[1.35rem] font-extrabold uppercase leading-[1.08] text-white sm:text-3xl" data-id="element-102" data-mp="381xjaspbqs7j">
          El sistema completo para enseñar{' '}
          <span className="text-brand-yellow" data-id="element-103" data-mp="39a378zszjdms">
            Matemática en 1.º año de secundaria
          </span>{' '}
          con una ruta clara y organizada
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-white/85 sm:text-[0.92rem]" data-id="element-104" data-mp="30h9crv4yw7oc">
          Accede a una estructura completa para planificar tus clases, explicar
          contenidos, trabajar con actividades, evaluar y reforzar el
          aprendizaje — sin perder horas buscando ejercicios, armando
          evaluaciones y preparando material desde cero.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.12
      }} className="mt-2 inline-block rounded-md bg-brand-yellow px-3 py-1.5 font-display text-[0.65rem] font-black uppercase leading-tight tracking-wide text-brand-navy sm:text-xs" data-id="element-105" data-mp="s2b7vyavsj55">
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-2 block overflow-hidden rounded-xl border-4 border-brand-yellow bg-white" data-id="element-106" data-mp="1b04bz3x8qz44">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-107" data-mp="x37falufynfb" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.2
      }} className="mt-3" data-id="element-108" data-mp="3hq25ev53m28s">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-109" data-mp="218tprvkjzaev">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-white/85" data-id="element-110" data-mp="2b0pmp3awkuhi">
            <span className="flex items-center gap-1" data-id="element-111" data-mp="2g0lqb1foujwj">
              <ZapIcon size={12} className="text-brand-yellow" data-id="element-112" data-mp="2g258ixkwn50y" />
              Acceso Digital Inmediato
            </span>
            <span className="text-white/50" data-id="element-113" data-mp="2p0qp4n6tg9z3">•</span>
            <span className="flex items-center gap-1" data-id="element-114" data-mp="2p10eq9ny8f49">
              <ShieldCheckIcon size={12} className="text-brand-sky" data-id="element-115" data-mp="2u03k5v7ucncr" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}